export default __webpack_public_path__ + "static/media/lamp.5bbb0700.mp3";